// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__EH6Ap","col":"styles_col__2A-_X","actions":"styles_actions__Ijhkw","conflict":"styles_conflict__z8_UA"};